module.exports = __webpack_public_path__ + "img/bekleding.eeb2ccfd.png";